import { render, staticRenderFns } from "./rp-sidebar-roles-list.vue?vue&type=template&id=f0a0ed3e"
import script from "./rp-sidebar-roles-list.vue?vue&type=script&lang=js"
export * from "./rp-sidebar-roles-list.vue?vue&type=script&lang=js"
import style0 from "./rp-sidebar-roles-list.vue?vue&type=style&index=0&id=f0a0ed3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports